
import { Vue, Component } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import DashboardBusiness from '../../components/Dashboards/DashboardBusiness.vue'
  @Component({
    components: { DashboardBusiness }
  })
export default class baohe extends Vue {
  mounted() {}
}
